export default __webpack_public_path__ + "static/media/SndLowerJDot.1d74e356.mp3";